import { __rest } from 'tslib';
import React from 'react';
import { styled, Card, LazyImage } from '@teko/ui';
import { Flex, Box } from 'reflexbox';
import { M as MobileLink } from './MobileLink-fcf22e0e.js';

const mapAvatarSize = {
    sm: 26,
    md: 42,
    lg: 58,
};
const SellerName = styled.div `
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    color: #0d80d0;
  }
`;
const Slogan = styled.div `
  font-size: 12px;
  line-height: 16px;
  color: #82869e;
`;
const StyledTick = styled.div `
  position: relative;
  display: inline-block;
  width: 14px;
  height: 14px;
  background-color: #52c401;
  margin-left: 4px;
  margin-top: 4px;
  border-radius: 50%;
  &:after {
    position: absolute;
    display: table;
    border: 1px solid #fff;
    border-top: 0;
    border-left: 0;
    transform: rotate(45deg) scale(1) translate(-50%, -50%);
    transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
    content: ' ';
    top: 50%;
    left: 25%;
    width: 4px;
    height: 7px;
    margin-left: 0.5px;
  }
`;
const SellerCard = (_a) => {
    var { avatar, name, slogan, showSlogan = true, showTick = true, avatarSize = 'md', link, isAvatarHidden = false } = _a, props = __rest(_a, ["avatar", "name", "slogan", "showSlogan", "showTick", "avatarSize", "link", "isAvatarHidden"]);
    return (React.createElement(Card, Object.assign({}, props),
        React.createElement(Flex, null,
            isAvatarHidden ? null : (React.createElement(Box, { marginRight: "8px", width: `${mapAvatarSize[avatarSize]}px`, style: { borderWidth: 1 } },
                React.createElement(LazyImage, { height: mapAvatarSize[avatarSize], width: mapAvatarSize[avatarSize], imageWidth: 100, src: avatar, aspectRatio: 1, contain: true, borderRadius: 999, border: true }))),
            React.createElement(Flex, { alignItems: "flex-start", flexDirection: "column", justifyContent: "center" },
                link ? (React.createElement(MobileLink, { href: link },
                    React.createElement("a", { target: "_blank", style: { color: 'unset', textDecoration: 'unset' } },
                        React.createElement(SellerName, null,
                            name,
                            " ",
                            showTick && React.createElement(StyledTick, null))))) : (React.createElement(SellerName, null,
                    name,
                    " ",
                    showTick && !isAvatarHidden && React.createElement(StyledTick, null))),
                slogan && showSlogan && React.createElement(Slogan, null, slogan)))));
};

export { SellerCard as S };
